import React__default, { useEffect, useState } from 'react';
import { DepartmentIcon, Button } from '@deal/components';
import { useApplicationContext, Application } from '../../../containers/ApplicationContext/index.js';
import MessageBubble from '../../MessageBubble/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { DepartmentType } from '../../../generated/types.js';
import { requestConfirmationRichCard } from '../../../services/richCardFactory.js';
import HeroWithImage from '../components/HeroWithImage/index.js';
import { useExperiment } from '@deal/experiment-js';
import ChevronUp from './chevron-up.svg.js';
import ChevronDown from './chevron-down.svg.js';
import { RequestConfirmationLeadComponent } from './RequestConfirmationLead.generated.js';
import styles from './styles.css.js';

var RequestConfirmationMessage = function RequestConfirmationMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      onLoaded = _a.onLoaded;
  var richCard = requestConfirmationRichCard(message);
  var leadId = richCard.leadId;
  useEffect(function () {
    onLoaded();
  }, []);
  return React__default.createElement(RequestConfirmationLeadComponent, {
    variables: {
      leadId: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      return React__default.createElement(CardContent, {
        message: message,
        lead: data.lead
      });
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

RequestConfirmationMessage.handlesMessage = function (message) {
  return !!requestConfirmationRichCard(message);
};

var CardContent = function CardContent(_a) {
  var lead = _a.lead,
      message = _a.message;
  var application = useApplicationContext().application;

  var _b = useState(false),
      showAllAttributes = _b[0],
      setShowAllAttributes = _b[1]; // Must group expert in same treatment as lead consumer


  var result = useExperiment({
    experiment: 'golf-path-budget-question-hide',
    defaultTreatment: 'off',
    overrideId: lead.consumer.experimentUserId
  }).result;
  var consumer = lead.consumer,
      latestRequest = lead.latestRequest,
      department = lead.department; // No point in rendering this card if you don't have a latest request or category

  if (!latestRequest || !lead.category) return null;
  var category = lead.category;
  var attributes = latestRequest.attributes ? latestRequest.attributes.filter(function (attribute) {
    return !!attribute.formatted;
  }) : [];
  var attributesToShowBizAndOps = result === 'hide-budget-from-experts' && (department === null || department === void 0 ? void 0 : department.type) === DepartmentType.GOLF ? attributes.filter(function (attribute) {
    return attribute.schema.name !== 'priceRangeUSD';
  }) : attributes;
  var attributesToShowConsumer = showAllAttributes ? attributes : attributes.slice(0, 3);
  var banner = category.contentAssets && category.contentAssets.bannerImages && category.contentAssets.bannerImages[0];
  return React__default.createElement(MessageBubble, {
    message: message
  }, React__default.createElement(HeroWithImage, {
    imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
    heroLabel: React__default.createElement(React__default.Fragment, null, ' ', category && category.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(DepartmentIcon, {
      className: styles.categoryIcon,
      departmentSlug: category.department.slug
    }), React__default.createElement("div", {
      className: styles.break
    }), consumer.firstName + "'s " + category.singularDisplayName.toLowerCase() + " request"))
  }), React__default.createElement("div", {
    className: styles.requestDetails
  }, React__default.createElement("div", {
    className: styles.categoryName
  }, category.singularDisplayName, " request details"), application === Application.BUSINESS || application === Application.OPERATIONS ? React__default.createElement(React__default.Fragment, null, attributesToShowBizAndOps.map(function (attribute) {
    return React__default.createElement("div", {
      key: attribute.formatted.name,
      className: styles.attribute
    }, React__default.createElement("div", {
      className: styles.attributeName
    }, attribute.formatted.name), React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: attribute.formatted.displayHtml
      },
      className: styles.attributeValue
    }));
  })) : React__default.createElement(React__default.Fragment, null, attributesToShowConsumer.map(function (attribute) {
    return React__default.createElement("div", {
      key: attribute.formatted.name,
      className: styles.attribute
    }, React__default.createElement("div", {
      className: styles.attributeName
    }, attribute.formatted.name), React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: attribute.formatted.displayHtml
      },
      className: styles.attributeValue
    }));
  }), attributes.length > 3 && React__default.createElement("div", {
    className: styles.seeMoreRow
  }, showAllAttributes ? React__default.createElement(Button, {
    variant: "primary-link",
    size: "small",
    className: styles.showMore,
    onClick: function onClick() {
      return setShowAllAttributes(false);
    }
  }, "Collapse Details ", React__default.createElement(ChevronUp, {
    className: styles.chevron
  })) : React__default.createElement(Button, {
    variant: "primary-link",
    size: "small",
    className: styles.showMore,
    onClick: function onClick() {
      return setShowAllAttributes(true);
    }
  }, "Expand All Details ", React__default.createElement(ChevronDown, {
    className: styles.chevron
  }))))));
};

export default RequestConfirmationMessage;
//# sourceMappingURL=index.js.map
